import { Chip } from '@mui/material'
import dayjs from 'dayjs'
import { useTranslation } from 'react-i18next'
import { AmericanFormattedDate } from '@/components/ui/date/AmericanFormattedDate'
import { useIsUS } from '@/hooks/useIsUS'

export function ChipDate({ date }: { date: string }) {
  const { t } = useTranslation()
  const isUS = useIsUS()

  return (
    <Chip
      color="secondary"
      label={
        isUS ? (
          <AmericanFormattedDate date={date} />
        ) : (
          <span>
            {dayjs(date).isSame(dayjs(), 'day') ? t(`moment:calendar:today`) : dayjs(date).format('DD/MM/YYYY')} - <b>{dayjs(date).format('HH[h]mm')}</b>
          </span>
        )
      }
      variant="filled"
    />
  )
}
